import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { Store } from '@ngrx/store';
import { LicenseState } from '@pixacare/domain';
import { selectUserClientLicense } from '@shared/store/licenses/licenses.selectors';
import { first } from 'rxjs';

@Injectable()
export class RedirectionService {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly authenticationService = inject(AuthenticationService);

  navigateToDefaultClientPage(clientCode: string): void {
    this.store
      .select(selectUserClientLicense(this.authenticationService.user.id, clientCode))
      .pipe(first())
      .subscribe((license) => {
        const supportRoute = ['/client', clientCode, 'admin', 'users'];
        const standardRoute = ['/client', clientCode, 'sequences'];
        const route = license?.state === LicenseState.SUPPORT ? supportRoute : standardRoute;
        this.router.navigate(route);
      });
  }
}
